import {isNilOrEmpty} from 'ramda-adjunct';

import {OMISSION_STRING} from '../constants/omissionString';

interface SoftTruncateOptions {
  omission: string;
  length: number;
}

const defaultOptions: SoftTruncateOptions = {
  omission: OMISSION_STRING,
  length: 25,
};

/**
 * Creates a safe regex pattern with a numeric length
 */
function createSafeTruncateRegex(length: number): RegExp {
  // Ensure length is a positive integer to prevent regex issues
  const safeLength = Math.max(0, Math.floor(length));
  return RegExp('^(.{' + safeLength + '}\\S*).*');
}

/**
 * @description Truncate text while keeping whole words.
 */
export function softTruncate(
  text: string,
  customOptions: Partial<SoftTruncateOptions> = defaultOptions
): string {
  const options = Object.assign({}, defaultOptions, customOptions);

  if (isNilOrEmpty(text)) {
    return '';
  }

  if (text.length <= options.length) {
    return text;
  }

  const replaceRegex = createSafeTruncateRegex(options.length);

  return text.replace(replaceRegex, '$1') + options.omission;
}
